/* template */
<template minapp="mpx" xlang="wxml"><div :style="[({color: '#CCCCCC'})] | transRpxStyle" class="crossed-price-container" v-if="(price)"><span v-if="(prefix)">{{ prefix }}</span><span class="price">￥{{ price }}</span></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m1220e10f"}'>
  .price
    text-decoration line-through
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1220e10f"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex1220e10f%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex1220e10f%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m1220e10f"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index1220e10f/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
